import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyRupees: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCurrencyRupees"><Path d="M4.5 2.5H19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 7.5H19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 21.5L4.5 12.75V12.5H9.5M10.7857 2.5H11.5C14.2614 2.5 16.5 4.73858 16.5 7.5C16.5 10.2614 14.2614 12.5 11.5 12.5H8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCurrencyRupees;
